import { useCallback, useMemo } from "react";
import { useFilters } from "../../../../../utils/hooks/useFilters";

export const useUrlPagination = (defaultPageSize = 10) => {
    const [filters, setFilters] = useFilters();

    const pageIndex = useMemo(() => Number(filters.page || 1) - 1, [filters.page]);
    const pageSize = useMemo(() => Number(filters.pageSize || defaultPageSize), [filters.pageSize, defaultPageSize]);

    const onPageChange = useCallback((index: number) => {
        setFilters("page", String(index + 1));
    }, [setFilters]);

    const onPageSizeChange = useCallback((size: number) => {
        setFilters({ pageSize: String(size), page: "1" });
    }, [setFilters]);

    return { pageIndex, pageSize, onPageChange, onPageSizeChange };
};
